import React, { useState } from 'react'
import classes from "./styles/faq.module.css";
import minus from "./dumble.png";
import plus from "./dumble.png";

const Faq1 = () => {
    const [box1 , setBox1] = useState(false);
    const [box2 , setBox2] = useState(false);
    const [box3 , setBox3] = useState(false);
    // const [box4 , setBox4] = useState(false);

    const handlebox1 = () => {
        setBox1(!box1);
    }
    const handlebox2 = () => {
        setBox2(!box2);
    }

    const handlebox3 = () => {
        setBox3(!box3);
    }
    // const handlebox4 = () => {
    //     setBox4(!box4);
    // }

  return (
    <div className={classes.Container}>
      <div className={`${box1 ? classes.boxOpen2 : classes.box} ${classes.boxMobile}`} onClick={handlebox1}>
            <div className={classes.upperCon}>
                <div>How is online fitness different from a gym workout?</div>
                <div className={`${classes.logoCon} ${box1 ? classes.rotateIcon : ''}`}><img src={box1 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>Our online coaching saves you <b>60% of the time</b> compared to a gym. You can train from anywhere with guided workouts,
                    live sessions, and personalized coaching. With small groups of 5 in each group you will be getting the required focus to
                    achieve your goals.
                </div>
            </div>
        </div>


        <div className={`${box2 ? classes.boxOpen : classes.box} ${classes.boxMobile}`} onClick={handlebox2}>
            <div className={classes.upperCon}>
                <div>I have a busy schedule. Can I still follow the program?</div>
                <div className={`${classes.logoCon} ${box2 ? classes.rotateIcon : ''}`}><img src={box2 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>Yes! We design flexible plans that t into your work-life balance, even if you travel frequently.</div>
            </div>
        </div>



        <div className={`${box3 ? classes.boxOpen : classes.box} ${classes.boxMobile}`} onClick={handlebox3}>
            <div className={classes.upperCon}>
                <div>I work from home and hardly move. Will this work for me?</div>
                <div className={`${classes.logoCon} ${box3 ? classes.rotateIcon : ''}`}><img src={box3 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>Yes! Our program includes structured <b>movement breaks, nutrition coaching, and strength training</b> to help you stay
                active despite a sedentary lifestyle.</div>
            </div>
        </div>

        {/* <div className={box4 ? classes.boxOpen : classes.box} onClick={handlebox4}>
            <div className={classes.upperCon}>
                <div>What if I miss a workout or have a busy week?</div>
                <div className={`${classes.logoCon} ${box4 ? classes.rotateIcon : ''}`}><img src={box4 ? minus : plus} alt='plus-minus-icon'/></div>
            </div>
            <div className={classes.lowerCon}>
                <div>Life happens! The program is flexible, and you’ll receive guidance on how to stay on track even during busy times.</div>
            </div>
        </div> */}
    </div>
  )
}

export default Faq1;
